<template>
<div>
    <h1 class="font-bold text-xl mb-5">
        <!-- <icon name="users" class="w-4 h-4 mr-2 fill-gray-400" />
        <inertia-link v-if="$page.props.auth.user.owner" class="text-enlace hover:text-indigo-600" :href="route('aspirantes.list')">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="margin: -27px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"/>
            </svg>
            Volver
        </inertia-link> -->
        <inertia-link class="flex items-center group py-3 hover:text-indigo-600" :href="route('aspirantes.list')">
            <icon name="chevron-double-left" class="w-4 h-4 mr-2" />
            <div>Volver</div>
        </inertia-link>
    </h1>
    <!--
    Ejemplo original de la documentación:
    https://tailwindui.com/components/application-ui/data-display/description-lists
    -->
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <description-header :title="aspirante.nombre_completo" sub-title="Detalles personales, estudios e intereses"></description-header>
        <div class="border-t border-gray-200">
            <dl>
                <description-row v-for="item in description_fields" :key="item.key" :label="item.label" :odd="item.odd">{{ item.value }}</description-row>
                <description-row label="Archivos subidos" :odd="true" >
                    <!-- <dl>
                        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2"> -->
                            <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                <description-adjunto-item v-for="adjunto in adjuntos" :key="adjunto.uuid" :file-name="adjunto.file_name" :description="adjunto.description" :download-link="adjunto.url"></description-adjunto-item>
                            </ul>
                        <!-- </dd>
                    </dl> -->
                </description-row>
                <description-row label="Cursos Formación Judicial" :odd="true">
                    <table class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 w-full">
                        <tr v-for="curso in aspirante.cursos" :key="curso.id" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                            <td class="border-t px-6 pt-6 pb-4 text-center">
                                {{curso.curso}}
                            </td>
                            <td class="border-t px-6 pt-6 pb-4 text-center">
                                    {{ curso.descripcion }}
                            </td>
                            <td class="border-t px-6 pt-6 pb-4 text-rigth">
                                <a v-for="media in curso.media" :key="media.id" :href="media.original_url" :download="media.file_name" class="flex items-center group py-3">
                                    <icon name="printer" class="w-5 h-5 mr-3" />
                                    <button type="button" class="text-indigo-300">{{ media.file_name }}</button>
                                </a>
                            </td>
                        </tr>
                    </table>
                </description-row>
                <description-row label="Designaciones" :odd="true" v-if="this.$page.props.auth.user.is_admin">
                  <table class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 w-full">
                    <tr v-for="designacion in aspirante.designaciones" :key="designacion.id" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                        <td class="border-t px-6 pt-6 pb-4 text-left text-gray-500">
                                <!-- {{ designacion.designado }} -->
                                {{designacion.designado | sino}}
                        </td>
                        <td class="border-t px-6 pt-6 pb-4 text-left">
                                {{ designacion.resolucion }}
                        </td>
                        <td class="border-t px-6 pt-6 pb-4 text-left">
                                {{  designacion.observacion }}
                        </td>
                        <td class="border-t px-6 pt-6 pb-4 text-left">
                                {{ designacion.fecha_asignacion | fecha }}
                        </td>
                    </tr>
                  </table>
              </description-row>
            </dl>
        </div>
    </div>
</div>
</template>

<script>

import DescriptionRow from '../../Shared/Descriptions/DescriptionRow'
import DescriptionHeader from '../../Shared/Descriptions/DescriptionHeader'
import Layout from '@/Shared/Layout'
import DescriptionAdjuntoItem from '../../Shared/Descriptions/DescriptionAdjuntoItem';
import Icon from '../../Shared/Icon'
import moment from 'moment';


export default {
  name: 'Description',
  components: {
    DescriptionAdjuntoItem,
    DescriptionHeader,
    DescriptionRow,
    Icon
  },
  props: {
    aspirante: Object,
    description_fields: Array,
    adjuntos: Array,
  },
  layout: Layout,
  data(){
    return {

      evenRow: 'bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6',
      oddRow: 'bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6',
    }
  },
  filters:{
    fecha(value){
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    sino(designacion){
        if(designacion == true){
            return 'SI'
        }
        return 'NO'
    },
  },
}
</script>

<style scoped>

</style>
